import React from 'react';

import SeatMap from './SeatMap';
import SeatLegend from './SeatLegend';
import SeatSelectionHeader from './SeatSelectionHeader';
import SeatSelectionFooter from './SeatSelectionFooter';
import ScheduleService from '../../services/schedule';
import './SeatSelection.scss';

class SeatSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSeats: [],
      heldSeats: [],
      pendingSeats: [],
      pendingReleaseSeats: [],
      conflictedSeats: [],
      // Seats the customer had selected that turned out to be unavailable
      // when they tried to confirm (admin block, race-conditioned booking, etc.)
      invalidatedSeats: [],
      validatingConfirm: false
    };
  }

  componentDidUpdate(prevProps) {
    // Reset selected seats and hold state when modal opens
    if (this.props.show && !prevProps.show) {
      this.setState({ selectedSeats: [], heldSeats: [], pendingSeats: [], pendingReleaseSeats: [], conflictedSeats: [], invalidatedSeats: [], validatingConfirm: false });
    }
    // Clear conflicted seats once fresh data arrives from the parent
    if (this.state.conflictedSeats && this.state.conflictedSeats.length > 0 && prevProps.temporaryTakenSeats !== this.props.temporaryTakenSeats) {
      this.setState({ conflictedSeats: [] });
    }
  }

  dismissInvalidatedNotice = () => {
    this.setState({ invalidatedSeats: [] });
  }

  handleSeatSelect = (seatId) => {
    if ((this.state.pendingSeats && this.state.pendingSeats.length > 0) ||
        (this.state.pendingReleaseSeats && this.state.pendingReleaseSeats.length > 0)) {
      return;
    }

    var selectedSeats = this.state.selectedSeats;
    var maxSeats = this.props.maxSeats;
    var maxSelectableRow = this.props.maxSelectableRow;
    var takenSeats = this.props.takenSeats || [];
    var temporaryTakenSeats = this.props.temporaryTakenSeats || [];

    // Block selection of FCFS-row seats (defense-in-depth)
    if (maxSelectableRow != null) {
      var rowMatch = seatId.match(/^(\d+)/);
      if (rowMatch && parseInt(rowMatch[1], 10) > maxSelectableRow) {
        return;
      }
    }

    // Don't allow selection of taken seats
    if (takenSeats.indexOf(seatId) !== -1 || temporaryTakenSeats.indexOf(seatId) !== -1) {
      return;
    }

    if (selectedSeats.indexOf(seatId) !== -1) {
      // Deselect -- release the hold
      this.setState(function(prevState) {
        return {
          selectedSeats: prevState.selectedSeats.filter(function(s) { return s !== seatId; }),
          heldSeats: prevState.heldSeats.filter(function(s) { return s !== seatId; }),
          pendingReleaseSeats: prevState.pendingReleaseSeats.concat([seatId])
        };
      });
      this.releaseSeatHold(seatId);
    } else if (selectedSeats.length < maxSeats) {
      // Select -- acquire a hold
      this.setState({
        selectedSeats: selectedSeats.concat([seatId])
      });
      this.acquireSeatHold(seatId);
    }
  }

  acquireSeatHold = (seatId) => {
    var scheduleBus = this.props.scheduleBus;
    var slot = this.props.slot;
    var sessionId = this.props.sessionId;
    var self = this;

    if (!scheduleBus || !slot || !sessionId) {
      return;
    }

    this.setState(function(prevState) {
      return { pendingSeats: prevState.pendingSeats.concat([seatId]) };
    });

    ScheduleService.holdSeat(scheduleBus, slot, seatId, sessionId)
      .then(function() {
        self.setState(function(prevState) {
          return {
            pendingSeats: prevState.pendingSeats.filter(function(s) { return s !== seatId; }),
            heldSeats: prevState.heldSeats.indexOf(seatId) === -1
              ? prevState.heldSeats.concat([seatId])
              : prevState.heldSeats
          };
        });
      })
      .catch(function(err) {
        if (err && err.conflict) {
          console.warn('[SeatSelection] Seat conflict:', seatId, err.message);
          var freshTempSeats = err.temporaryTakenSeats || null;
          var freshTakenSeats = err.takenSeats || null;
          self.setState(function(prevState) {
            var update = {
              pendingSeats: prevState.pendingSeats.filter(function(s) { return s !== seatId; }),
              selectedSeats: prevState.selectedSeats.filter(function(s) { return s !== seatId; }),
              conflictedSeats: [],
            };
            if (!freshTempSeats && !freshTakenSeats) {
              update.conflictedSeats = (prevState.conflictedSeats || []).indexOf(seatId) === -1
                ? (prevState.conflictedSeats || []).concat([seatId])
                : (prevState.conflictedSeats || []);
            }
            return update;
          });
          if (freshTempSeats && self.props.onUpdateTempSeats) {
            self.props.onUpdateTempSeats(freshTempSeats);
          }
          if (freshTakenSeats && self.props.onUpdateTakenSeats) {
            self.props.onUpdateTakenSeats(freshTakenSeats);
          }
          if (!freshTempSeats && !freshTakenSeats) {
            if (self.props.onSilentRefresh) {
              self.props.onSilentRefresh();
            } else if (self.props.onRefresh) {
              self.props.onRefresh();
            }
          }
        } else {
          console.error('[SeatSelection] Hold error:', err);
          self.setState(function(prevState) {
            return { pendingSeats: prevState.pendingSeats.filter(function(s) { return s !== seatId; }) };
          });
        }
      });
  }

  releaseSeatHold = (seatId) => {
    var scheduleBus = this.props.scheduleBus;
    var slot = this.props.slot;
    var sessionId = this.props.sessionId;
    var self = this;

    if (!scheduleBus || !slot || !sessionId) {
      this.setState(function(prevState) {
        return { pendingReleaseSeats: prevState.pendingReleaseSeats.filter(function(s) { return s !== seatId; }) };
      });
      return;
    }

    ScheduleService.releaseSeat(scheduleBus, slot, seatId, sessionId)
      .then(function() {
        self.setState(function(prevState) {
          return { pendingReleaseSeats: prevState.pendingReleaseSeats.filter(function(s) { return s !== seatId; }) };
        });
        if (self.props.onSilentRefresh) {
          self.props.onSilentRefresh();
        }
      })
      .catch(function(err) {
        console.error('[SeatSelection] Release error:', err);
        self.setState(function(prevState) {
          return { pendingReleaseSeats: prevState.pendingReleaseSeats.filter(function(s) { return s !== seatId; }) };
        });
      });
  }

  handleRefresh = () => {
    console.log('[SeatSelection] handleRefresh fired, clearing all selections and holds');
    this.releaseAllHoldsOnClose();
    this.setState({ selectedSeats: [], heldSeats: [], pendingSeats: [], pendingReleaseSeats: [], conflictedSeats: [], invalidatedSeats: [], validatingConfirm: false });
    if (this.props.onRefresh) {
      this.props.onRefresh();
    }
  }

  handleSkip = () => {
    // Release all holds before skipping
    this.releaseAllHoldsOnClose();
    this.setState({ selectedSeats: [], heldSeats: [] });
    if (this.props.onSkip) {
      this.props.onSkip();
    }
  }

  handleConfirm = () => {
    if ((this.state.pendingSeats && this.state.pendingSeats.length > 0) ||
        (this.state.pendingReleaseSeats && this.state.pendingReleaseSeats.length > 0)) {
      return;
    }

    var self = this;
    var selectedSeats = this.state.selectedSeats;
    var pricing = this.props.pricing;
    var scheduleBus = this.props.scheduleBus;
    var slot = this.props.slot;
    var sessionId = this.props.sessionId;

    if (selectedSeats.length === 0) {
      return;
    }

    // Re-validate against current backend state before letting the customer
    // proceed. Catches the case where someone (admin block, another customer
    // booking) invalidated a held seat between hold and confirm.
    this.setState({ validatingConfirm: true });
    ScheduleService.getSeatInfo(scheduleBus, slot, sessionId)
      .then(function (data) {
        var unavailable = {};
        (data.takenSeats || []).forEach(function (s) { unavailable[s] = true; });
        (data.temporaryTakenSeats || []).forEach(function (s) { unavailable[s] = true; });

        var invalid = selectedSeats.filter(function (s) { return unavailable[s]; });

        if (invalid.length > 0) {
          // Drop the dead seats; surface the warning. Customer can pick others
          // and click Confirm again. Refresh parent so the seat map repaints.
          self.setState(function (prev) {
            var dropSet = {};
            invalid.forEach(function (s) { dropSet[s] = true; });
            return {
              validatingConfirm: false,
              selectedSeats: prev.selectedSeats.filter(function (s) { return !dropSet[s]; }),
              heldSeats: prev.heldSeats.filter(function (s) { return !dropSet[s]; }),
              invalidatedSeats: invalid
            };
          });
          if (self.props.onSilentRefresh) self.props.onSilentRefresh();
          else if (self.props.onRefresh) self.props.onRefresh();
          return;
        }

        // All good — proceed. Backend will clear holds on successful booking.
        self.setState({ validatingConfirm: false });
        if (self.props.onConfirm) {
          self.props.onConfirm(selectedSeats, pricing);
        }
      })
      .catch(function (err) {
        console.error('[SeatSelection] Confirm validation failed:', err);
        // Network error etc. — let them through; backend is the final gate.
        self.setState({ validatingConfirm: false });
        if (self.props.onConfirm) {
          self.props.onConfirm(selectedSeats, pricing);
        }
      });
  }

  handleClose = () => {
    // Release all holds before closing
    this.releaseAllHoldsOnClose();
    this.setState({ selectedSeats: [], heldSeats: [] });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  releaseAllHoldsOnClose = () => {
    var sessionId = this.props.sessionId;
    if (!sessionId) {
      return;
    }
    // Fire-and-forget bulk release
    ScheduleService.releaseAllHolds(sessionId)
      .catch(function(err) {
        console.error('[SeatSelection] Release all holds error:', err);
      });
  }

  handleBackdropClick = (e) => {
    if (e.target.classList.contains('seat-selection-modal')) {
      this.handleClose();
    }
  }

  // Calculate total using backend pricing only
  calculateTotal() {
    var selectedSeats = this.state.selectedSeats;
    var pricing = this.props.pricing;
    var bus = this.props.bus;

    var basePrice = (pricing && pricing.basePrice) || (bus && bus.price) || 0;
    var tiers = (pricing && pricing.tiers) || [];

    var total = 0;
    for (var i = 0; i < selectedSeats.length; i++) {
      var seatId = selectedSeats[i];
      var seatPrice = this.getSeatPrice(seatId, basePrice, tiers);
      total += seatPrice;
    }
    return total;
  }

  // Get price for a single seat using backend tiers
  getSeatPrice(seatId, basePrice, tiers) {
    var rowMatch = seatId.match(/^(\d+)/);
    if (!rowMatch) return basePrice;

    var rowNumber = parseInt(rowMatch[1], 10);

    // Find matching tier from backend data
    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      if (tier.rows && tier.rows.indexOf(rowNumber) !== -1) {
        return basePrice + (tier.additionalPrice || 0);
      }
    }

    return basePrice;
  }

  // Get only the addon price for a seat (not including base)
  getSeatAddon(seatId, tiers) {
    var rowMatch = seatId.match(/^(\d+)/);
    if (!rowMatch) return 0;

    var rowNumber = parseInt(rowMatch[1], 10);

    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      if (tier.rows && tier.rows.indexOf(rowNumber) !== -1) {
        return tier.additionalPrice || 0;
      }
    }

    return 0;
  }

  // Calculate total addon price for all selected seats
  calculateAddonTotal() {
    var selectedSeats = this.state.selectedSeats;
    var pricing = this.props.pricing;
    var tiers = (pricing && pricing.tiers) || [];

    var total = 0;
    for (var i = 0; i < selectedSeats.length; i++) {
      total += this.getSeatAddon(selectedSeats[i], tiers);
    }
    return total;
  }

  render() {
    var show = this.props.show;
    var bus = this.props.bus;
    var maxSeats = this.props.maxSeats;
    var tripType = this.props.tripType;
    var loading = this.props.loading;
    var error = this.props.error;
    var busLayout = this.props.busLayout;
    var pricing = this.props.pricing;
    var takenSeats = this.props.takenSeats || [];
    var temporaryTakenSeats = (this.props.temporaryTakenSeats || []).concat(this.state.conflictedSeats || []);
    var selectedSeats = this.state.selectedSeats;

    // Don't render if not shown or no bus
    if (!show || !bus) {
      return null;
    }

    var title = tripType === 'depart' ? 'Select Departing Seats' : 'Select Returning Seats';
    var basePrice = (pricing && pricing.basePrice) || bus.price || 0;

    // Determine what content to show - only ONE of these will render.
    // Once we have a busLayout, keep the seat map mounted across subsequent
    // refreshes so the polling loop doesn't cause loading-spinner jitter.
    var content = null;
    var hasLayout = busLayout && busLayout.columns && busLayout.totalRows;

    if (loading === true && !hasLayout) {
      // STATE 1: Initial load (no data yet)
      content = (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Fetching seat arrangement...</p>
        </div>
      );
    } else if (error && !hasLayout) {
      // STATE 2: Error on initial load
      content = (
        <div className="error-container">
          <p className="error-message">{error}</p>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={this.handleRefresh}
          >
            Try Again
          </button>
        </div>
      );
    } else if (hasLayout) {
      // STATE 3: Data ready - show seat map
      var self = this;
      var pricingTiers = (pricing && pricing.tiers) || [];
      var isRefreshing = loading === true;
      var hasPending = (this.state.pendingSeats && this.state.pendingSeats.length > 0) ||
        (this.state.pendingReleaseSeats && this.state.pendingReleaseSeats.length > 0);

      content = (
        <div className={'seat-map-container' + (isRefreshing ? ' refreshing' : '') + (hasPending ? ' checking' : '')}>
          {isRefreshing && (
            <div className="seat-refresh-overlay">
              <div className="seat-refresh-indicator">
                <div className="loading-spinner small"></div>
                <span>Checking availability...</span>
              </div>
            </div>
          )}
          <SeatMap
            busLayout={busLayout}
            selectedSeats={selectedSeats}
            pendingSeats={this.state.pendingSeats}
            pendingReleaseSeats={this.state.pendingReleaseSeats}
            takenSeats={takenSeats}
            temporaryTakenSeats={temporaryTakenSeats}
            basePrice={basePrice}
            pricingTiers={pricingTiers}
            maxSeats={maxSeats}
            maxSelectableRow={this.props.maxSelectableRow}
            onSeatSelect={this.handleSeatSelect}
          />
          <div className="legend-container">
            <SeatLegend />
            <div className="seat-info-note">
              <p>Seats from row 6 onwards will be on a first-come-first-served basis at boarding</p>
            </div>
            {selectedSeats.length > 0 && (
              <div className="selected-seats-summary">
                <div className="summary-title">Selected Seats</div>
                <div className="selected-seats-list">
                  {selectedSeats.map(function(seatId) {
                    var addonPrice = self.getSeatAddon(seatId, pricingTiers);
                    return (
                      <div key={seatId} className="selected-seat-item">
                        <span className="seat-id">{seatId}</span>
                        <span className="seat-price">{addonPrice > 0 ? '+$' + addonPrice : '$0'}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    } else {
      // STATE 4: Waiting for data
      content = (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Preparing seat layout...</p>
        </div>
      );
    }

    var departureCity = this.props.departureCity;
    var arrivalCity = this.props.arrivalCity;
    var departureTime = this.props.departureTime;
    var busTypeName = this.props.busTypeName;

    return (
      <div className="seat-selection-modal" onClick={this.handleBackdropClick}>
        <div className="seat-selection-dialog">
          <div className="seat-selection-content">
            <SeatSelectionHeader
              title={title}
              maxSeats={maxSeats}
              selectedCount={selectedSeats.length}
              onRefresh={this.handleRefresh}
              onClose={this.handleClose}
              refreshing={loading === true && !!hasLayout}
              holdTimerRemaining={this.props.holdTimerRemaining}
            />

            {/* Trip info bar */}
            {(departureCity || arrivalCity || departureTime) && (
              <div className="trip-info-bar">
                <div className="trip-info-route">
                  <span className="trip-info-city">{departureCity}</span>
                  <span className="trip-info-arrow">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="5" y1="12" x2="19" y2="12" />
                      <polyline points="12 5 19 12 12 19" />
                    </svg>
                  </span>
                  <span className="trip-info-city">{arrivalCity}</span>
                </div>
                <div className="trip-info-details">
                  {departureTime && <span className="trip-info-time">{departureTime}</span>}
                  {busTypeName && <span className="trip-info-bus-type">{busTypeName}</span>}
                </div>
              </div>
            )}

            <div className="seat-selection-body">
              <div className="instruction-text">
                Select/UnSelect your seats by clicking on them.
              </div>
              {this.state.invalidatedSeats.length > 0 && (
                <div className="seat-invalidated-notice" role="alert">
                  <strong>Heads up:</strong>{' '}
                  Seat{this.state.invalidatedSeats.length === 1 ? '' : 's'}{' '}
                  <strong>{this.state.invalidatedSeats.join(', ')}</strong>{' '}
                  {this.state.invalidatedSeats.length === 1 ? 'is' : 'are'} no longer available and{' '}
                  {this.state.invalidatedSeats.length === 1 ? 'has' : 'have'} been removed from your selection. Please pick another seat.
                  <button
                    type="button"
                    className="seat-invalidated-dismiss"
                    onClick={this.dismissInvalidatedNotice}
                    aria-label="Dismiss"
                  >
                    ×
                  </button>
                </div>
              )}
              {content}
            </div>

            <SeatSelectionFooter
              totalPrice={this.calculateAddonTotal()}
              selectedCount={selectedSeats.length}
              maxSeats={maxSeats}
              onSkip={this.handleSkip}
              onConfirm={this.handleConfirm}
              canConfirm={selectedSeats.length > 0 && !this.state.validatingConfirm && (!this.state.pendingSeats || this.state.pendingSeats.length === 0) && (!this.state.pendingReleaseSeats || this.state.pendingReleaseSeats.length === 0)}
              checkingAvailability={(this.state.pendingSeats && this.state.pendingSeats.length > 0) || (this.state.pendingReleaseSeats && this.state.pendingReleaseSeats.length > 0)}
            />
          </div>
        </div>

      </div>
    );
  }
}

export default SeatSelection;
